import { render, staticRenderFns } from "./TrashAdmin.vue?vue&type=template&id=0d4053a1&"
import script from "./TrashAdmin.vue?vue&type=script&lang=js&"
export * from "./TrashAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports